import React, { Component } from 'react'
import { Select, Spin, Button, Icon } from 'antd'
import { getAttribute, getModelName } from '../utils/models'
import Format from '../containers/Format'
import ShowModal from '../containers/ShowModal'
import FormItem from './FormItem'
import { request } from '../utils/sockets'
import custom from '../config/custom'
import _ from 'lodash'

const Option = Select.Option

class SelectInput extends Component {

    constructor(props) {
        super(props)

        this.attribute = getAttribute(this.props.model, this.props.attribute)
        this.modelName = getModelName(this.props.model, this.props.attribute)
        this.state = {
            items: [],
            fetching: false
        }
    }

    componentWillMount() {
        this.search()
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.value !== this.props.value) {
            this.addItemValue(nextProps.value)
        }
    }

    handleSearch = _.debounce(query => {
        this.search(query)
    }, 300)

    async search(query) {
        this.setState({
            items: [],
            fetching: true
        })

        try {
            const response = await request(`${custom.baseUrl}/pagination/${this.modelName}`, {
                params: {
                    query,
                    page: 1,
                    pageSize: 10
                }
            })

            this.setState({
                items: response.items
            })
        } catch (error) {
            console.error(error)
        }

        this.setState({ fetching: false })
    }

    async addItemValue(value) {
        this.setState({ fetching: true })

        try {
            const response = await request(`${custom.baseUrl}/${this.modelName}?id=${value}`)
            const filteredItems = _.filter(response, item => !_.find(this.state.items, i => i.id === item.id))

            if (filteredItems.length) {
                this.setState({
                    items: [
                        ...filteredItems,
                        ...this.state.items
                    ]
                })
            }
        } catch (error) {
            console.error(error)
        }

        this.setState({ fetching: false })
    }

    render() {
        const { getFieldDecorator } = this.props.form
        return (
            <FormItem {...this.props}>
                {getFieldDecorator(this.props.attribute, this.props.fieldSettings)(
                    <Select
                        size='large'
                        loading={this.state.fetching}
                        disabled={this.props.disabled}
                        style={{ width: '100%' }}
                        allowClear={!this.attribute.required}
                        onSearch={query => { this.handleSearch(query) }}
                        onChange={this.props.handleChange}
                        filterOption={false}
                        showSearch
                        placeholder={this.props.placeholder}
                        notFoundContent={this.state.fetching ? <Spin size="small" /> : null}
                    >
                        {this.state.items.map((item, index) => (
                            <Option key={index} value={item.id || item}>
                                <Format
                                    model={this.props.model}
                                    attribute={this.props.attribute}
                                    value={item}
                                />
                            </Option>
                        ))}
                    </Select>
                )}
                {
                    this.props.showAdd &&
                    !this.props.disabled &&
                    <ShowModal
                        type="form"
                        model={this.modelName}
                        belongsTo={this.props.belongsTo}
                    >
                        <div className="input-add-button">
                            <Button type="dashed"><Icon type="plus" /></Button>
                        </div>
                    </ShowModal>
                }
            </FormItem>
        )
    }

}

export default SelectInput


// WEBPACK FOOTER //
// ./src/inputs/Select.js